import React, { useState, useEffect } from 'react';
import { Link } from 'gatsby';
import scrollTo from 'gatsby-plugin-smoothscroll';
import Image from 'components/image';
import Style from 'styles/components/scroll_to_top.module.scss';

const ScrollToTop = () => {
  const [visible, setVisible] = useState(false);
  const [bannerVisible, setBannerVisible] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className={`${Style.wrapper} ${visible ? Style.visible : ''}`}>
      <button
        className={Style.btn}
        onClick={() => scrollTo('#root')}
        aria-label="ページの先頭へ戻る"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="18 15 12 9 6 15" />
        </svg>
        <span className={Style.btnText}>TOP</span>
      </button>
      {bannerVisible && (
        <div className={Style.bannerWrap}>
          <button
            className={Style.bannerClose}
            onClick={() => setBannerVisible(false)}
            aria-label="バナーを閉じる"
          >
            ✕
          </button>
          <Link to="/recruit/" className={Style.banner}>
            <Image className={Style.bannerImg} filename="e-ize_recruit_banner.png" alt="2027新卒/インターン 積極採用中" />
          </Link>
        </div>
      )}
    </div>
  );
};

export default ScrollToTop;
